<template>
  <div>
    <basic-container>
      <div style='display:flex;justify-content: center;'>
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          style="width:500px;display: flex;flex-flow: column;justify-content: center;align-items: center;"
        >
          <el-form-item label="模板名称">
            <div style='width:300px;'>
              <el-input
                v-model="form.templateName"
                placeholder='请输入模板名称'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="模板编码">
            <div style='width:300px;display:flex;'>
              <el-input
                v-model="form.templateCode"
                placeholder='请输入模板编码'
              ></el-input>
              <span style="color:#CC1414;font-size:14px;position:absolute;left:320px;width:450px;">
                大写字母加_的格式，如INFORMED_BY_INSTALLATION
              </span>
            </div>
          </el-form-item>
          <el-form-item label="模板内容">
            <div style='width:300px;'>
              <el-input
                v-model="form.content"
                height="200px"
                type="textarea"
                :autosize="{ minRows: 2}"
                placeholder='请输入模板内容'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <p style="color:#CC1414;font-size:16px;width:320px;margin-left: -115px;">
              提示：<br>
              模版内容参数值如下所示，请根据实际情况填写模版内容，避免审核失败，请严格按照要求进行填写！<br>
              公司名称：business<br>
              客户姓名：name<br>
              服务名称：type<br>
              所有参数格式为${参数值}
            </p>
          </el-form-item>
          <el-form-item style='text-align: center;margin:100px 0'>
            <el-button @click="resetSubmit">重置</el-button>
            <el-button
              type="primary"
              @click="onSubmit"
            >提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { addTemplate } from "@/api/salesCloud/messageTipModule";
export default {
  data() {
    return {
      form: {}
    };
  },
  created() {},
  methods: {
    resetSubmit() {
      this.form = {};
    },
    onSubmit() {
      let params = this.form;
      params.moduleType = "CUSTOMER";
      params.remarks = this.form.templateName;
      params.templateType = "ALI_NOTICE_CODE";
      params.useType = "USE_SYSTEM";
      let item = {
        close: true,
        label: "新增消息提醒模板",
        value: "/salesCloud/messageTipModule/add"
      };
      addTemplate(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/salesCloud/messageTipModule",
              label: "消息提醒模板管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    }
  }
};
</script>

<style>
</style>